import { type CommunityDetail, useCommunityQuery } from '@pba/react-network';
import { useMemo } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { usePermissions } from 'permissions';
import { Button, DownLineIcon, Dropdown, ExitLineIcon, Flex, type MenuProps, Modal } from 'ui';
import { useLeaveCommunity } from '../../queries';
import { CommunityJoinedStatusBadge } from './community-joined-status-badge';

type P = {
  community: CommunityDetail;
};

const CommunityJoinedStatus = ({ community }: P) => {
  const { t } = useTranslation();
  const [modal, contextHolder] = Modal.useModal();
  const { canLeaveCommunityDetail } = usePermissions();
  const { isRefetching: isReloadingCommunity } = useCommunityQuery({ filter: {}, id: community.id });
  const { isPending: isLeavingCommunity, mutate: leaveCommunity } = useLeaveCommunity();

  const dropdownLeave: MenuProps = useMemo(
    () => ({
      items: [
        {
          danger: true,
          icon: <ExitLineIcon />,
          key: 'leave',
          label: t('Leave Community'),
        },
      ],
      onClick() {
        modal.confirm({
          content: (
            <Trans
              components={{ strong: <strong /> }}
              i18nKey="Are you sure you want to leave <strong>{{communityName}}</strong> community?"
              values={{ communityName: community.name }}
            />
          ),
          icon: <ExitLineIcon type="error" />,
          okText: t('Leave'),
          onOk() {
            leaveCommunity({ id: community.id });
          },
          title: t('Leave community?'),
          type: 'error',
        });
      },
    }),
    [community, leaveCommunity, modal, t],
  );

  const isLoading = isReloadingCommunity || isLeavingCommunity;

  return (
    <>
      {contextHolder}
      {canLeaveCommunityDetail({ community }) ? (
        <Dropdown disabled={isLoading} menu={dropdownLeave} trigger={['click']}>
          <Button loading={isLoading} type="text">
            <Flex align="center" gap="xs">
              <CommunityJoinedStatusBadge />
              <DownLineIcon />
            </Flex>
          </Button>
        </Dropdown>
      ) : (
        <CommunityJoinedStatusBadge />
      )}
    </>
  );
};

export default CommunityJoinedStatus;
